import { m } from "@vega-core/paraglide/messages";

export const DealCancelledBanner = () => (
  <div
    className="max-w-3xl mx-auto border border-border/primary rounded-companyBorderRadius card-paddings-default text-center space-y-3"
    data-testid="report-cancelled"
  >
    <h2 className="heading-5">{m.coInvestments_report_cancelled_title()}</h2>
    <p className="body-base-regular text-text/secondary">
      {m.coInvestments_report_cancelled_description()}
    </p>
  </div>
);
